import {constantRoutes} from '@/router'

const state = {
    routes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = routes && routes.length > 0 ? constantRoutes.concat(routes) : []
    }
}

const actions = {
    setRoutes({commit}, asyncRoutes) {
        return new Promise(resolve => {
            commit('SET_ROUTES', asyncRoutes || [])
            resolve(asyncRoutes || [])
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
